/**
 * PreviousReport screen styles - V3 Design
 */

import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

import AppStyles from '../../AppStyles';

const styles = StyleSheet.create({
  // V3: Clean white container instead of gold
  container: {
    flex: 1,
    backgroundColor: AppStyles.colorSet.whiteColor,
  },
  // V3: Title section with clean styling
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: hp(2),
    paddingHorizontal: 16,
    backgroundColor: AppStyles.colorSet.whiteColor,
  },
  title: {
    textAlign: 'center',
  },
  refreshButton: {
    position: 'absolute',
    right: 16,
    padding: 8,
    borderRadius: 8,
  },
  // V3: Light background for report list area
  listContainer: {
    flex: 1,
    backgroundColor: '#F8F9FA',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    paddingTop: hp(1.5),
    paddingHorizontal: 8,
  },
  // Legacy style for backward compatibility
  orangeContainer: {
    flex: 1,
    alignItems: 'center',
    borderRadius: 12,
    backgroundColor: '#F8F9FA',
    paddingVertical: 5,
    paddingLeft: hp(1),
    marginTop: hp(0.5),
  },
  emptyState: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: hp(10),
  },
  loadingMore: {
    paddingVertical: 20,
    alignItems: 'center',
  },
});

export default styles;
